import React from "react";
import {
  FileText,
  Workflow,
  Users2,
  MessageSquare,
  BarChart3,
  Shield,
  Search,
} from "lucide-react";

import ProductPage from "../Components/ProductPage";
import { colors as DS } from "../../design-system";

export default function ProductATS() {
  return (
    <ProductPage
      meta={{ index: "P-03", code: "ATS" }}
      hero={{
        title: (
          <>
            Track every applicant.
            <br />
            <span style={{ color: `${DS.forest}80` }}>Hire with signal.</span>
          </>
        ),
        subtitle: "Applicant Tracking System",
        description:
          "A pipeline that screens, scores and schedules itself so your recruiters spend their time talking to people, not chasing spreadsheets.",
        accent: DS.product.ats,
        icon: FileText,
        animation: "mockup",
      }}
      features={{
        title: "Streamline every stage of hiring.",
        subtitle: "From application to offer, manage it all in one place with the same data, the same audit trail and the same UI.",
        items: [
          {
            icon: Workflow,
            title: "Customisable workflows",
            description: "Design hiring pipelines that mirror your real process drag, drop, automate.",
          },
          {
            icon: Users2,
            title: "Centralised candidate database",
            description: "One source of truth with advanced search, tags and de-dup across every job.",
          },
          {
            icon: Search,
            title: "AI screening",
            description: "Resume parsing + fit scoring narrows 200 applicants to the 20 worth talking to.",
          },
          {
            icon: MessageSquare,
            title: "Automated communications",
            description: "Templated emails, scheduled nudges and SMS so candidates never go silent.",
          },
          {
            icon: Shield,
            title: "Collaboration & approvals",
            description: "Team feedback, scorecards and approval gates that keep everyone aligned.",
          },
          {
            icon: BarChart3,
            title: "Analytics & reporting",
            description: "Live funnel, time-to-hire, source-of-hire the metrics your CFO actually asks about.",
          },
        ],
      }}
      flow={{
        title: "Your pipeline. Linear, predictable, fast.",
        stages: [
          { title: "Source",    desc: "Collect from boards, agencies and direct applies." },
          { title: "Screen",    desc: "AI parsing + fit scoring filters the noise." },
          { title: "Interview", desc: "Schedule, conduct and capture structured scorecards." },
          { title: "Hire",      desc: "Make offers, run e-boarding and hand off to HRMS." },
        ],
      }}
      stats={{
        title: "Numbers customers see in 90 days.",
        items: [
          { value: "70%", label: "less manual screening" },
          { value: "3.4×", label: "faster time-to-hire" },
          { value: "85%", label: "ai match accuracy" },
          { value: "92%",  label: "recruiter satisfaction" },
        ],
      }}
      ctaPrimary={{ label: "Request demo",   href: "/contact" }}
      ctaSecondary={{ label: "Open ATS app", href: "/ats/login" }}
      finalCta={{
        title: (
          <>
            Hire smarter.
            <br />
            <span style={{ color: `${DS.forest}80` }}>Build your bench.</span>
          </>
        ),
        subtitle: "Join teams shipping offers faster with stronger candidate experience.",
        ctaPrimary:   { label: "Book a walkthrough", href: "/contact" },
        ctaSecondary: { label: "Explore the suite",  href: "/products" },
      }}
    />
  );
}
